module.exports = __webpack_public_path__ + "static/media/logo-manvert-mwa.7ce16e2a.jpg";